import React from "react";
import { Users } from "lucide-react";
import { fileUrl } from "@/lib/files";

// "Part of {Company}" trust badge, with the company logo when one is uploaded.
export const TeamBadge = ({ name, logo, testid, large = false }) => (
  <span data-testid={testid} className={`mt-1 inline-flex items-center gap-1.5 font-medium rounded-full bg-[#2D6A4F]/10 text-[#2D6A4F] ${large ? "text-[11px] pl-1 pr-2.5 py-1" : "text-[10px] pl-0.5 pr-2 py-0.5"}`}>
    {logo
      ? <img src={fileUrl(logo)} alt="" className={`${large ? "w-5 h-5" : "w-4 h-4"} rounded-full object-contain bg-white border border-[#1E3F33]/10`} data-testid={testid ? `${testid}-logo` : undefined} />
      : <Users className="w-3 h-3 ml-1"/>}
    Part of {name}
  </span>
);

export const CompanyLogo = ({ logo, name, size = "w-12 h-12", testid }) => (
  <div className={`${size} rounded-xl bg-white border border-[#1E3F33]/10 overflow-hidden flex items-center justify-center shrink-0`} data-testid={testid}>
    {logo ? <img src={fileUrl(logo)} alt={`${name} logo`} className="w-full h-full object-contain p-1" />
      : <span className="font-heading text-[#1E3F33] text-lg">{(name || "?").charAt(0).toUpperCase()}</span>}
  </div>
);
